import { BaseButton } from '@photosi/rn-components/buttons/base-button/BaseButton';
import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';
import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { Image } from 'expo-image';
import { styles } from './SingleColumnToolOption.styles';
import { SingleColumnToolOptionProps } from './SingleColumnToolOption.types';
import { getFormattedPrice } from 'src/helpers/price.helper';
import { generateTestID, lookupChoiceTestID } from 'src/helpers/testIDs.helper';
import { ToolOptionTooltip } from '../../../tool-option-tooltip/ToolOptionTooltip';
import { View } from 'react-native';
import { TestIDs } from 'src/constants/testIDs.constants';

export const SingleColumnToolOption = ({
  index,
  optionCode,
  isActive,
  isPriceVisible,
  isDisabled,
  isSelected,
  previewImageUrl,
  title,
  price,
  description,
  onPress,
  hint,
}: SingleColumnToolOptionProps) => {
  const buttonTestID = lookupChoiceTestID(optionCode, index);
  return (
    <ToolOptionTooltip hint={hint}>
      <BaseButton
        style={[styles.button, isSelected && styles.buttonActive]}
        innerStyle={styles.buttonInner}
        focusStyle={styles.buttonFocus}
        testID={buttonTestID}
        onPress={onPress}
        focusId={buttonTestID}
        focusOrder={index}
        focusGroup={FocusGroups.TOOLBAR_OPTIONS}
        focusable={isActive}
        disabled={isDisabled}
        accessibilityRole="button"
        accessibilityLabel={title ?? `single column tool option ${buttonTestID}`}
        accessible={true}
      >
        {() => {
          return (
            <>
              <Image
                // @ts-ignore
                crossOrigin="anonymous"
                source={previewImageUrl}
                contentFit="cover"
                style={[styles.image, !previewImageUrl && styles.imagePlaceholder, isDisabled && styles.imageDisabled]}
                testID={generateTestID(buttonTestID, TestIDs.IMAGE_WRAPPER)}
              />
              {title && (
                <TextLato
                  style={[
                    styles.text,
                    styles.titleText,
                    isSelected && styles.textActive,
                    isDisabled && styles.textDisabled,
                  ]}
                  testID={generateTestID(buttonTestID, TestIDs.TITLE)}
                >
                  {title}
                </TextLato>
              )}
              {isPriceVisible && typeof price === 'number' && price > 0 && (
                <TextLato
                  style={[
                    styles.text,
                    styles.priceText,
                    isSelected && styles.textActive,
                    isDisabled && styles.textDisabled,
                  ]}
                  testID={generateTestID(buttonTestID, TestIDs.PRICE)}
                >
                  {getFormattedPrice({ price })}
                </TextLato>
              )}
              <View style={styles.descriptionContainer} testID={generateTestID(buttonTestID, TestIDs.DESCRIPTION)}>
                {description?.split('\n').map((line, index) => (
                  <TextLato
                    style={[
                      styles.text,
                      styles.subtitleText,
                      isSelected && styles.textActive,
                      isDisabled && styles.textDisabled,
                    ]}
                    key={`description-line-${line}`}
                  >
                    {line}
                  </TextLato>
                ))}
              </View>
            </>
          );
        }}
      </BaseButton>
    </ToolOptionTooltip>
  );
};

SingleColumnToolOption.displayName = 'SingleColumnToolOption';
